import { useListing, ListingShell, FilterSelect } from "../components/Listing";
import { Check, PageHeader, TextField } from "../components/kit";
import { JobCard } from "../components/cards";
import { OtherOfficialSources } from "../components/OtherOfficialSources";
import { label, useFetch } from "../lib/api";

const WM = [["remote", "Remote"], ["hybrid", "Hybrid"], ["onsite", "On-site"]];
const EXP = [["entry", "Entry level"], ["mid", "Mid level"], ["senior", "Senior level"]];
const ET = [["full_time", "Full-time"], ["part_time", "Part-time"], ["contract", "Contract"], ["internship", "Internship"]];
const POSTED = [["1", "Last 24 hours"], ["7", "Last 7 days"], ["30", "Last 30 days"]];
const SAL = [["300000", "₹3 lakh+"], ["600000", "₹6 lakh+"], ["1000000", "₹10 lakh+"], ["2000000", "₹20 lakh+"]];

export default function Jobs() {
  const L = useListing("/jobs", { per_page: "100" });
  const meta = useFetch("/meta");
  const { params, set } = L;
  const find = (opts, v) => (opts.find((o) => o[0] === v) || [v, label(v)])[1];
  const chips = [
    params.q && { key: "q", label: `Keyword: ${params.q}` },
    params.location && { key: "location", label: `Location: ${params.location}` },
    params.work_mode && { key: "work_mode", label: find(WM, params.work_mode) },
    params.experience_level && { key: "experience_level", label: find(EXP, params.experience_level) },
    params.employment_type && { key: "employment_type", label: find(ET, params.employment_type) },
    params.sector && { key: "sector", label: `Sector: ${params.sector}` },
    params.salary_min && { key: "salary_min", label: find(SAL, params.salary_min) },
    params.posted_within && { key: "posted_within", label: find(POSTED, params.posted_within) },
    params.accessibility && { key: "accessibility", label: "Has accessibility information" },
    params.accommodation && { key: "accommodation", label: "Has accommodation policy" },
    params.pwd_eligibility && { key: "pwd_eligibility", label: params.pwd_eligibility },
  ].filter(Boolean);
  return (
    <>
      <PageHeader eyebrow="Jobs" title="Find a job" description="Search roles by title, skill, employer or keyword. Accessibility information is shown only when the employer has provided it." />
      <ListingShell L={L} chips={chips} noun="jobs" saveKind="job" searchPlaceholder="Job title, skill, employer or keyword"
        sortOptions={[["relevance", "Relevance"], ["newest", "Newest"]]}
        renderItem={(j) => <JobCard job={j} />}
        emptyTitle="No jobs match your search" emptyBody="Try fewer filters, a different keyword or a wider location."
        filters={<>
          <form onSubmit={(e) => { e.preventDefault(); set("location", e.target.elements["filter-location"].value.trim()); }}>
            <TextField id="filter-location" label="Location" defaultValue={params.location || ""} key={params.location || ""} hint="Press Enter to apply" />
          </form>
          <FilterSelect k="work_mode" label="Work arrangement" options={WM} params={params} set={set} />
          <FilterSelect k="experience_level" label="Experience" options={EXP} params={params} set={set} />
          <FilterSelect k="employment_type" label="Employment type" options={ET} params={params} set={set} />
          <FilterSelect k="salary_min" label="Salary (per year)" options={SAL} params={params} set={set} />
          <FilterSelect k="sector" label="Sector" options={meta.data?.job_sectors || []} params={params} set={set} />
          <FilterSelect k="posted_within" label="Date posted" options={POSTED} params={params} set={set} />
          <fieldset><legend className="font-semibold mb-1">Accessibility (optional)</legend>
            <Check id="filter-accessibility" label="Employer provided workplace accessibility information" checked={!!params.accessibility} onChange={(e) => set("accessibility", e.target.checked ? "true" : "")} />
            <Check id="filter-accommodation" label="Employer has an accommodation policy" checked={!!params.accommodation} onChange={(e) => set("accommodation", e.target.checked ? "true" : "")} />
            <Check id="filter-pwd-eligibility" label="PwD eligibility confirmed by the source" checked={params.pwd_eligibility === "PwD Eligibility Confirmed"} onChange={(e) => set("pwd_eligibility", e.target.checked ? "PwD Eligibility Confirmed" : "")} />
          </fieldset>
        </>} />
      <div className="container-x pb-10"><OtherOfficialSources kind="job" /></div>
    </>
  );
}
